import React, { Component } from "react";
import { IoPlayCircle } from "react-icons/io5";
import "styled-components/macro";

import guessMyDevice from "./utils/guess-my-device";

export default class ButtonWatchTrailer extends Component {
  device = guessMyDevice();
  render() {
    const { color, handleOpenTrailerVideo } = this.props;

    return (
      <button
        onClick={handleOpenTrailerVideo}
        css={`
          display: inline-flex;
          align-items: center;
          margin: 7px 0;
          padding: 7px 12px 7px 16px;
          font-family: Inter, Arial, sans-serif;
          font-size: ${this.device !== "mobile" ? 16 : 14}px;
          font-weight: 600;
          color: ${color || "#4747fa"};
          background: none;
          border-radius: 200px;
          border: 1px solid transparent;
          cursor: pointer;
          :hover {
            background: hsl(240 30% 91% / 1);
            border: 1px solid transparent;
          }
          :focus {
            background: hsl(240 30% 91% / 1);
            outline: none;
            box-shadow: none;
            border: 1px solid hsl(240 30% 86% / 1);
          }
        `}
      >
        <div
          css={`
            margin-right: 5px;
          `}
        >
          Watch the trailer
        </div>
        <IoPlayCircle
          css={`
            width: 25px;
            height: 25px;
          `}
        ></IoPlayCircle>
      </button>
    );
  }
}
